import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

/**
 * Wrap a component to add location and params properties.
 *
 * @param {Element} WrappedComponent The component to wrap.
 *
 * @returns {Element} The wrapped component
 */
const withRouter = (WrappedComponent) => {
  const WithRouter = (props) => {
    const location = useLocation();
    const params = useParams();

    return <WrappedComponent location={location} params={params} {...props} />;
  };

  WithRouter.displayName = `withRouter(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithRouter;
};

export default withRouter;
